
<div class="submenu-container" *ngIf="items &amp;&amp; items.length &gt; 0">
  <div class="submenu-items-container">
    <div class="submenu-items">
      <div class="submenu-item" *ngFor="let item of items" [class.active]="isActive(item)"><span (click)="clickLink(item, $event)">{{ item.name }}</span><a class="seo-link" [href]="item.url">{{ item.name }}</a></div>
    </div>
  </div>
</div>